import type { ResolvedComponent } from "@inertiajs/react"

import {
  type InertiaPageModule,
  applyDefaultLayout,
} from "@/lib/inertia-page-layout"

const pageModules = import.meta.glob<InertiaPageModule>("../pages/**/*.tsx")

export async function resolvePage(name: string): Promise<ResolvedComponent> {
  const importPage = pageModules[`../pages/${name}.tsx`]
  if (!importPage) {
    throw new Error(`Page not found: ${name}`)
  }

  const module = (await importPage()) as InertiaPageModule | undefined
  // A cancelled vite:preloadError fulfills with undefined while the page
  // reloads (lib/stale-chunk). Reading `.default` threw TypeError on channel
  // pages and every other page whose chunk missed (TANGOTUBETV-18R).
  if (!module?.default) return new Promise<ResolvedComponent>(() => undefined)
  await module.ready
  return applyDefaultLayout(module)
}
